import React from 'react';
import { getName } from 'iso-639-1';
import PropTypes from "prop-types";

export const CountryName = ({ countryCode }) => {
    const countryName = (countryCode === 'br' || countryCode === 'pt') ? getName('pt') : getName(countryCode);

    return (
        <div>
            {countryName}
        </div>
    );
};

CountryName.propTypes = {
    countryCode: PropTypes.string,
}